import { v4 as uuid } from "uuid";
/**
 * id:uuid(), Category Database can be added here.
 * You can add id:uuid(), category of your wish with different attributes
 * */

export const categories = [
  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "11",
    image: "/assets/category_img/film.jpg",
    category: "Film",
    type: "multiple",
    difficulty: "medium",
    questions: [
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "medium",
        question:
          "Which retired American football quarterback played himself in &#039;Ace Ventura: Pet Detective&#039; and &#039;Little Nicky&#039;?",
        correct_answer: "Dan Marino",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Dan Marino", "Joe Montana", "Tom Brady", "Barry Sanders"],
        incorrect_answers: ["John Elway", "Tom Brady", "Joe Montana"],
      },
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "easy",
        question:
          "Who starred in the film 1973 movie &quot;Enter The Dragon&quot;?",
        correct_answer: "Bruce Lee",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Jackie Chan", "Bruce Lee", "Jet Li", " Yun-Fat Chow"],
        incorrect_answers: ["Jackie Chan", "Jet Li", " Yun-Fat Chow"],
      },
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "medium",
        question:
          "Who voices the main character Blu in the 2011 animated film &quot;Rio&quot;?",
        correct_answer: "Jesse Eisenberg",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Michael Cera",
          "Jonah Hill",
          "Jesse Eisenberg",
          "Zach Galifianakis",
        ],
        incorrect_answers: ["Michael Cera", "Jonah Hill", "Zach Galifianakis"],
      },
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "medium",
        question:
          "Darth Vader&#039;s famous reveal to Luke is iconic. But which of these is the right one?",
        correct_answer: "&quot;No. I am your father.&quot;",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "&quot;Luke, I am your father.&quot;",
          "&quot;You&#039;re wrong. I am your father.&quot;",
          "&quot;The truth is that I am your father.&quot;",
          "&quot;No. I am your father.&quot;",
        ],
        incorrect_answers: [
          "&quot;Luke, I am your father.&quot;",
          "&quot;You&#039;re wrong. I am your father.&quot;",
          "&quot;The truth is that I am your father.&quot;",
        ],
      },
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "easy",
        question:
          "When does &quot;Rogue One: A Star Wars Story&quot; take place chronologically in the series?",
        correct_answer: "Between Episode 3 and 4",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "After Episode 6",
          "Before Episode 1",
          "Between Episode 3 and 4",
          "Between Episode 4 and 5",
        ],
        incorrect_answers: [
          "After Episode 6",
          "Before Episode 1",
          "Between Episode 4 and 5",
        ],
      },
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "easy",
        question:
          "In the movie &quot;Blade Runner&quot;, what is the term used for human-like androids ?",
        correct_answer: "Replicants",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Cylons", "Replicants", "Synthetics", "Skinjobs"],
        incorrect_answers: ["Cylons", "Synthetics", "Skinjobs"],
      },
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "medium",
        question: "In Finding Nemo, what was the name of Nemo&#039;s mom?",
        correct_answer: "Coral",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Sandy", "Pearl", "Coral", "Shelly"],
        incorrect_answers: ["Sandy", "Pearl", "Shelly"],
      },
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "easy",
        question:
          "What is the name of the fictional retro-mod band starring Austin Powers as the lead vocalist?",
        correct_answer: "Ming Tea",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Cough Fi", "Spear Mint", "Mister E", "Ming Tea"],
        incorrect_answers: ["Cough Fi", "Spear Mint", "Mister E"],
      },
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "easy",
        question: "Who directed the Kill Bill movies?",
        correct_answer: "Quentin Tarantino",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Quentin Tarantino",
          "Arnold Schwarzenegger",
          "David Lean",
          "Stanley Kubrick",
        ],
        incorrect_answers: [
          "Arnold Schwarzenegger",
          "David Lean",
          "Stanley Kubrick",
        ],
      },
      {
        category: "Entertainment: Film",
        type: "multiple",
        difficulty: "medium",
        question:
          "After India, which country produces the second most movies per year?",
        correct_answer: "Nigeria",
        alphaKey: ["A", "B", "C", "D"],
        options: ["United States", "Nigeria", "China", "France"],
        incorrect_answers: ["United States", "China", "France"],
      },
    ],
  },
  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "9",
    image: "/assets/category_img/book.jpg",
    category: "General Knowledge",
    type: "multiple",
    difficulty: "easy",
    questions: [
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "easy",
        question:
          "Virgin Trains, Virgin Atlantic and Virgin Racing, are all companies owned by which famous entrepreneur?   ",
        correct_answer: "Richard Branson",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Alan Sugar",
          "Donald Trump",
          "Bill Gates",
          "Richard Branson",
        ],
        incorrect_answers: ["Alan Sugar", "Donald Trump", "Bill Gates"],
      },
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "easy",
        question: "Red Vines is a brand of what type of candy?",
        correct_answer: "Licorice",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Lollipop", "Licorice", "Chocolate", "Bubblegum"],
        incorrect_answers: ["Lollipop", "Chocolate", "Bubblegum"],
      },
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "medium",
        question: "What alcoholic drink is mainly made from juniper berries?",
        correct_answer: "Gin",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Gin", "Vodka", "Rum", "Tequila"],
        incorrect_answers: ["Vodka", "Rum", "Tequila"],
      },
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "medium",
        question: "Who is the founder of &quot;The Lego Group&quot;?",
        correct_answer: "Ole Kirk Christiansen",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          " Jens Niels Christiansen",
          "Kirstine Christiansen",
          " Gerhardt Kirk Christiansen",
          "Ole Kirk Christiansen",
        ],
        incorrect_answers: [
          " Jens Niels Christiansen",
          "Kirstine Christiansen",
          " Gerhardt Kirk Christiansen",
        ],
      },
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "medium",
        question: "What is the last letter of the Greek alphabet?",
        correct_answer: "Omega",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Mu", "Omega", "Epsilon", "Kappa"],
        incorrect_answers: ["Mu", "Epsilon", "Kappa"],
      },
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "easy",
        question: "What company developed the vocaloid Hatsune Miku?",
        correct_answer: "Crypton Future Media",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Crypton Future Media", "Sega", "Sony", "Yamaha Corporation"],
        incorrect_answers: ["Sega", "Sony", "Yamaha Corporation"],
      },
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "easy",
        question:
          "Which of the following is the IATA code for Manchester Airport?",
        correct_answer: "MAN",
        alphaKey: ["A", "B", "C", "D"],
        options: ["EGLL", "LHR", "EGCC", "MAN"],
        incorrect_answers: ["EGLL", "LHR", "EGCC"],
      },
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "medium",
        question: "Which country has the most Trappist breweries?",
        correct_answer: "Belgium",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Netherlands", "France", "USA", "Belgium"],
        incorrect_answers: ["Netherlands", "France", "USA"],
      },
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "medium",
        question: "What is the full title of the Prime Minister of the UK?",
        correct_answer: "First Lord of the Treasury",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Duke of Cambridge",
          "First Lord of the Treasury",
          "Her Majesty&#039;s Loyal Opposition",
          "Manager of the Crown Estate",
        ],
        incorrect_answers: [
          "Duke of Cambridge",

          "Her Majesty&#039;s Loyal Opposition",
          "Manager of the Crown Estate",
        ],
      },
      {
        category: "General Knowledge",
        type: "multiple",
        difficulty: "easy",
        question: "What is the profession of Elon Musk&#039;s mom, Maye Musk?",
        correct_answer: "Model",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Professor", "Model", "Biologist", "Musician"],
        incorrect_answers: ["Professor", "Biologist", "Musician"],
      },
    ],
  },
  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "23",
    image: "/assets/category_img/history.jpg",
    category: "History",
    type: "multiple",
    difficulty: "easy",
    questions: [
      {
        category: "History",
        type: "multiple",
        difficulty: "medium",
        question: "Who was the first explorer to sail to North America?",
        correct_answer: "Leif Erikson",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Leif Erikson",
          "Christopher Columbus",
          "Amerigo Vespucci",
          "Ferdinand Magellan",
        ],
        incorrect_answers: [
          "Christopher Columbus",
          "Amerigo Vespucci",
          "Ferdinand Magellan",
        ],
      },
      {
        category: "History",
        type: "multiple",
        difficulty: "medium",
        question: "On what day did Germany invade Poland?",
        correct_answer: "September 1, 1939",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "September 1, 1939",
          "June 22, 1941",
          "July 7, 1937",
          "December 7, 1941",
        ],
        incorrect_answers: [
          "December 7, 1841",
          "June 22, 1941",
          "July 7, 1937",
        ],
      },
      {
        category: "History",
        type: "multiple",
        difficulty: "medium",
        question:
          "In the War of the Pacific (1879 - 1883), Bolivia lost its access to the Pacific Ocean after being defeated by which South American country?",
        correct_answer: "Chile",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Peru", "Chile", "Brazil", "Argentina"],
        incorrect_answers: ["Peru", "Brazil", "Argentina"],
      },
      {
        category: "History",
        type: "multiple",
        difficulty: "medium",
        question: "How many times was Albert Einstein married in his lifetime?",
        correct_answer: "Twice",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Five", "Thrice", "Twice", "Once"],
        incorrect_answers: ["Five", "Thrice", "Once"],
      },
      {
        category: "History",
        type: "multiple",
        difficulty: "hard",
        question:
          "Who invented the &quot;Flying Shuttle&quot; in 1738; one of the key developments in the industrialization of weaving?",
        correct_answer: "John Kay",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "James Hargreaves",
          "Richard Arkwright",
          "John Kay",
          "John Deere",
        ],
        incorrect_answers: [
          "James Hargreaves",
          "Richard Arkwright",
          "John Deere",
        ],
      },
      {
        category: "History",
        type: "multiple",
        difficulty: "medium",
        question:
          "When Christopher Columbus sailed to America, what was the first region he arrived in?",
        correct_answer: "The Bahamas Archipelago",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "The Bahamas Archipelago",
          "Florida",
          "Isthmus of Panama",
          "Nicaragua",
        ],
        incorrect_answers: ["Florida", "Isthmus of Panama", "Nicaragua"],
      },
      {
        category: "History",
        type: "multiple",
        difficulty: "easy",
        question: "How long did World War II last?",
        correct_answer: "6 years",
        alphaKey: ["A", "B", "C", "D"],
        options: ["4 years", "5 years", "6 years", "7 years"],
        incorrect_answers: ["4 years", "5 years", "7 years"],
      },
      {
        category: "History",
        type: "multiple",
        difficulty: "medium",
        question:
          "In World War I, what was the name of the alliance of Germany, Austria-Hungary, the Ottoman Empire, and Bulgaria?",
        correct_answer: "The Central Powers",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "The Axis Powers",
          "The Central Powers",
          "The Federation of Empires",
          "Authoritarian Alliance",
        ],
        incorrect_answers: [
          "The Axis Powers",

          "The Federation of Empires",
          "Authoritarian Alliance",
        ],
      },
      {
        category: "History",
        type: "multiple",
        difficulty: "medium",
        question:
          "On which aircraft carrier did the Doolitte Raid launch from on April 18, 1942 during World War II?",
        correct_answer: "USS Hornet",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "USS Enterprise",
          "USS Lexington",
          "USS Saratoga",
          "USS Hornet",
        ],
        incorrect_answers: ["USS Enterprise", "USS Lexington", "USS Saratoga"],
      },
      {
        category: "History",
        type: "multiple",
        difficulty: "medium",
        question: "Which U.S. President was in office when the Gulf War began?",
        correct_answer: "George H. W. Bush",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Richard Nixon",
          "George W. Bush ",
          "George H. W. Bush",
          "Ronald Regan",
        ],
        incorrect_answers: ["Richard Nixon", "George W. Bush ", "Ronald Regan"],
      },
    ],
  },

  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "15",
    image: "/assets/category_img/games.jpg",
    category: "Video Games",
    type: "multiple",
    difficulty: "easy",
    questions: [
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "medium",
        question: "When was the Sega Genesis released in Japan?",
        correct_answer: "October 29, 1988",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "August 14, 1989",
          "November 30, 1990",
          "September 1, 1986",
          "October 29, 1988",
        ],
        incorrect_answers: [
          "August 14, 1989",
          "November 30, 1990",
          "September 1, 1986",
        ],
      },
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "medium",
        question: "Who&#039;s the creator of Geometry Dash?",
        correct_answer: "Robert Topala",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Scott Cawthon",
          "Adam Engels",
          "Robert Topala",
          "Andrew Spinks",
        ],
        incorrect_answers: ["Scott Cawthon", "Adam Engels", "Andrew Spinks"],
      },
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "easy",
        question:
          "In the game Half-Life, which enemy is showcased as the final boss?",
        correct_answer: "The Nihilanth",
        alphaKey: ["A", "B", "C", "D"],
        options: ["The Nihilanth", "Dr. Wallace Breen", "G-Man", "The Gonarch"],
        incorrect_answers: ["Dr. Wallace Breen", "G-Man", "The Gonarch"],
      },
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "hard",
        question:
          "In the original &quot;Super Mario Bros.&quot;, what is the acceleration of Mario if he was in free fall?",
        correct_answer: "91.28 m/s^2",
        alphaKey: ["A", "B", "C", "D"],
        options: ["110  m/s^2", "9.42  m/s^2", "4.4  m/s^2", "91.28 m/s^2"],
        incorrect_answers: ["110  m/s^2", "9.42  m/s^2", "4.4  m/s^2"],
      },
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "hard",
        question:
          "How long are all the cutscenes from Metal Gear Solid 4 (PS3, 2008) combined?",
        correct_answer: "8 hours",
        alphaKey: ["A", "B", "C", "D"],
        options: ["4 hours", "8 hours", "12 hours", "5 hours"],
        incorrect_answers: ["4 hours", "12 hours", "5 hours"],
      },
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "medium",
        question:
          "In PROTOTYPE 2, which of the following abilities/weapons is NOT obtained by an Evolved?",
        correct_answer: "Tendrils",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Blade", "Tendrils", "Bio-Bomb", "Pack Leader"],
        incorrect_answers: ["Blade", "Bio-Bomb", "Pack Leader"],
      },
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "medium",
        question:
          "In the game &quot;Persona 4&quot;, what is the canonical name of the protagonist?",
        correct_answer: "Yu Narukami",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Chino Mashido",
          "Tunki Sunada",
          "Yu Narukami",
          "Masaki Narinaka",
        ],
        incorrect_answers: ["Chino Mashido", "Tunki Sunada", "Masaki Narinaka"],
      },
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "easy",
        question:
          "What household item make the characters of &quot;Steins; Gate&quot; travel through time?",
        correct_answer: "Microwave",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Computer", "Refrigerator", "Televison", "Microwave"],
        incorrect_answers: ["Computer", "Refrigerator", "Televison"],
      },
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "easy",
        question:
          "In &quot;Call Of Duty: Zombies&quot;, what is the name of the machine that upgrades weapons?",
        correct_answer: "Pack-A-Punch",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Pack-A-Punch", "Wunderfizz", "Gersch Device", "Mule Kick"],
        incorrect_answers: ["Wunderfizz", "Gersch Device", "Mule Kick"],
      },
      {
        category: "Entertainment: Video Games",
        type: "multiple",
        difficulty: "medium",
        question:
          "Which of these games takes place in the Irish town of Doolin, with the option to play as one of the characters, Ellen and Keats?",
        correct_answer: "Folklore",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Folklore",
          "Shadow of the Colossus",
          "ICO",
          "Beyond Good &amp; Evil",
        ],
        incorrect_answers: [
          "Shadow of the Colossus",

          "ICO",
          "Beyond Good &amp; Evil",
        ],
      },
    ],
  },
  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "10",
    image: "/assets/category_img/book.jpg",
    category: "Books",
    type: "multiple",
    difficulty: "medium",
    questions: [
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "hard",
        question: "Who wrote the novel &quot;Moby-Dick&quot;?",
        correct_answer: "Herman Melville",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Herman Melville",
          "William Golding",
          "William Shakespeare",
          "J. R. R. Tolkien",
        ],
        incorrect_answers: [
          "William Golding",
          "William Shakespeare",
          "J. R. R. Tolkien",
        ],
      },
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "easy",
        question:
          "What was the name of Captain Nemo&#039;s submarine in &quot;20,000 Leagues Under the Sea&quot;?",
        correct_answer: "The Nautilus",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "The Neptune",
          "The Nautilus",
          "The Poseidon  ",
          "The Atlantis",
        ],
        incorrect_answers: ["The Neptune", "The Poseidon  ", "The Atlantis"],
      },
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "medium",
        question:
          "Who wrote the 1967 horror novel &quot;Rosemary&#039;s Baby&quot;?",
        correct_answer: "Ira Levin",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Stephen King", "Robert Bloch", "Ira Levin", "Mary Shelley"],
        incorrect_answers: ["Stephen King", "Robert Bloch", "Mary Shelley"],
      },
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "easy",
        question:
          "Which famous spy novelist wrote the childrens&#039; story &quot;Chitty-Chitty-Bang-Bang&quot;?",
        correct_answer: "Ian Fleming",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Joseph Conrad",
          "Ian Fleming",
          "John Buchan",
          "Graham Greene",
        ],
        incorrect_answers: ["Joseph Conrad", "John Buchan", "Graham Greene"],
      },
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "hard",
        question:
          "In the &quot;Harry Potter&quot; series, what is Headmaster Dumbledore&#039;s full name?",
        correct_answer: "Albus Percival Wulfric Brian Dumbledore",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Albus Valum Jetta Mobius Dumbledore",
          "Albus Percival Wulfric Brian Dumbledore",
          "Albus James Lunae Otto Dumbledore",
          "Albus Valencium Horatio Kul Dumbledore",
        ],
        incorrect_answers: [
          "Albus Valum Jetta Mobius Dumbledore",
          "Albus James Lunae Otto Dumbledore",
          "Albus Valencium Horatio Kul Dumbledore",
        ],
      },
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "easy",
        question: "How many Harry Potter books are there?",
        correct_answer: "7",
        alphaKey: ["A", "B", "C", "D"],
        options: ["8", "5", "6", "7"],
        incorrect_answers: ["8", "5", "6"],
      },
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "easy",
        question:
          "What is the title of the first Sherlock Holmes book by Arthur Conan Doyle?",
        correct_answer: "A Study in Scarlet",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "The Sign of the Four",
          "A Case of Identity",
          "A Study in Scarlet",
          "The Doings of Raffles Haw",
        ],
        incorrect_answers: [
          "The Sign of the Four",
          "A Case of Identity",
          "The Doings of Raffles Haw",
        ],
      },
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "medium",
        question:
          "What is the make and model of the tour vehicles in &quot;Jurassic Park&quot; (1990)?",
        correct_answer: "1989 Toyota Land Cruiser",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "1989 Toyota Land Cruiser",
          "1989 Jeep Wrangler YJ Sahar",
          "1989 Ford Explorer XLT",
          "Mercedes M-Class",
        ],
        incorrect_answers: [
          "1989 Jeep Wrangler YJ Sahar",
          "1989 Ford Explorer XLT",
          "Mercedes M-Class",
        ],
      },
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "medium",
        question:
          "Which novel by John Grisham was conceived on a road trip to Florida while thinking about stolen books with his wife?",
        correct_answer: "Camino Island",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Rogue Lawyer",
          "Gray Mountain",
          "Camino Island",
          "The Litigators",
        ],
        incorrect_answers: ["Rogue Lawyer", "Gray Mountain", "The Litigators"],
      },
      {
        category: "Entertainment: Books",
        type: "multiple",
        difficulty: "medium",
        question:
          "Who is the author of the series &quot;Malazan Book of the Fallen&quot;?",
        correct_answer: "Steven Erikson",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Steven Erikson",
          "Ian Cameron Esslemont",
          "George R. R. Martin",
          "J. R. R. Tolkien",
        ],
        incorrect_answers: [
          "Ian Cameron Esslemont",
          "George R. R. Martin",
          "J. R. R. Tolkien",
        ],
      },
    ],
  },
  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "17",
    image: "/assets/category_img/science.jpg",
    category: "Science & Nature",
    type: "multiple",
    difficulty: "medium",
    questions: [
      {
        category: "Science & Nature",
        type: "boolean",
        difficulty: "easy",
        question: "Igneous rocks are formed by excessive heat and pressure.",
        correct_answer: "False",
        alphaKey: ["A", "B", "C", "D"],
        options: ["true", "false"],
        incorrect_answers: ["True"],
      },
      {
        category: "Science & Nature",
        type: "multiple",
        difficulty: "medium",
        question: "What is the colour of unoxidized blood?",
        correct_answer: "Red",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Blue", "Purple", "Green", "Red"],
        incorrect_answers: ["Blue", "Purple", "Green"],
      },
      {
        category: "Science & Nature",
        type: "multiple",
        difficulty: "hard",
        question: "Which is the chemical name of H2O?",
        correct_answer: "Dihydrogen Monoxide",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Dihydrogen Monoxide",
          "Ammonium chloride",
          "Anhydrous Sodium Carbonate",
          "Manganese dioxide",
        ],
        incorrect_answers: [
          "Ammonium chloride",
          "Anhydrous Sodium Carbonate",
          "Manganese dioxide",
        ],
      },
      {
        category: "Science & Nature",
        type: "multiple",
        difficulty: "easy",
        question: "How many planets make up our Solar System?",
        correct_answer: "8",
        alphaKey: ["A", "B", "C", "D"],
        options: ["7", "8", "9", "6"],
        incorrect_answers: ["7", "9", "6"],
      },
      {
        category: "Science & Nature",
        type: "multiple",
        difficulty: "medium",
        question:
          "What does the yellow diamond on the NFPA 704 fire diamond represent?",
        correct_answer: "Reactivity",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Health", "Flammability", "Reactivity", "Radioactivity"],
        incorrect_answers: ["Health", "Flammability", "Radioactivity"],
      },
      {
        category: "Science & Nature",
        type: "multiple",
        difficulty: "easy",
        question: "What is the standard atomic weight of a Plutonium nucleus?",
        correct_answer: "244",
        alphaKey: ["A", "B", "C", "D"],
        options: ["94", "244", "481", "128"],
        incorrect_answers: ["94", "481", "128"],
      },
      {
        category: "Science & Nature",
        type: "multiple",
        difficulty: "hard",
        question: "How much radiation does a banana emit?",
        correct_answer: "0.1 Microsievert",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "0.1 Microsievert",
          "0.3 Microsievert",
          "0.5 Microsievert",
          "0.7 Microsievert",
        ],
        incorrect_answers: [
          "0.3 Microsievert",
          "0.5 Microsievert",
          "0.7 Microsievert",
        ],
      },
      {
        category: "Science & Nature",
        type: "multiple",
        difficulty: "medium",
        question: "What is the unit of electrical capacitance?",
        correct_answer: "Farad",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Gauss", "Farad", "Henry", "Watt"],
        incorrect_answers: ["Gauss", "Henry", "Watt"],
      },
      {
        category: "Science & Nature",
        type: "multiple",
        difficulty: "medium",
        question:
          "Which desert is the only desert in the world where the &quot;Saguaro&quot; cactus grows indigenously?",
        correct_answer: "The Sonoran Desert",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "The Gobi Desert",
          "The Yuma Desert",
          "The Arabian Desert",
          "The Sonoran Desert",
        ],
        incorrect_answers: [
          "The Gobi Desert",
          "The Yuma Desert",
          "The Arabian Desert",
        ],
      },
      {
        category: "Science & Nature",
        type: "multiple",
        difficulty: "hard",
        question: "How many protons are in an oxygen atom?",
        correct_answer: "Eight",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Four", "Two", "Six", "eight"],
        incorrect_answers: ["Four", "Two", "Six"],
      },
    ],
  },
  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "20",
    image: "/assets/category_img/mythology.jpg",
    category: "Mythology",
    type: "multiple",
    difficulty: "hard",
    questions: [
      {
        category: "Mythology",
        type: "multiple",
        difficulty: "easy",
        question:
          "The ancient Roman god of war was commonly known as which of the following?",
        correct_answer: "Mars",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Jupiter", "Juno", "Ares", "Mars"],
        incorrect_answers: ["Jupiter", "Juno", "Ares"],
      },
      {
        category: "Mythology",
        type: "boolean",
        difficulty: "easy",
        question: "In Norse mythology, Thor once dressed as a woman.",
        correct_answer: "true",
        alphaKey: ["A", "B", "C", "D"],
        options: ["true", "false"],
        incorrect_answers: ["False"],
      },
      {
        category: "Mythology",
        type: "multiple",
        difficulty: "easy",
        question: "Who was the King of Gods in Ancient Greek mythology?",
        correct_answer: "Zeus",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Zeus", "Poseidon", "Hera", "Hades"],
        incorrect_answers: ["Apollo", "Hermes", "Poseidon"],
      },
      {
        category: "Mythology",
        type: "boolean",
        difficulty: "easy",
        question: "According to Greek Mythology, Zeus can control lightning.",
        correct_answer: "True",
        alphaKey: ["A", "B", "C", "D"],
        options: ["true", "false"],
        incorrect_answers: ["False"],
      },
      {
        category: "Mythology",
        type: "multiple",
        difficulty: "easy",
        question: "The greek god Poseidon was the god of what?",
        correct_answer: "The Sea",
        alphaKey: ["A", "B", "C", "D"],
        options: ["War", "Sun", "Fire", "The Sea"],
        incorrect_answers: ["War", "Sun", "Fire"],
      },
      {
        category: "Mythology",
        type: "multiple",
        difficulty: "easy",
        question:
          "Which figure from Greek mythology traveled to the underworld to return his wife Eurydice to the land of the living?",
        correct_answer: "Orpheus",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Orpheus", "Hercules", "Perseus", "Daedalus"],
        incorrect_answers: ["Hercules", "Perseus", "Daedalus"],
      },
      {
        category: "Mythology",
        type: "multiple",
        difficulty: "easy",
        question: "In most traditions, who was the wife of Zeus?",
        correct_answer: "Hera",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Hera", "Aphrodite", "Athena", "Hestia"],
        incorrect_answers: ["Aphrodite", "Athena", "Hestia"],
      },
      {
        category: "Mythology",
        type: "boolean",
        difficulty: "easy",
        question: "According to Greek Mythology, Atlas was an Olympian God.",
        correct_answer: "False",
        alphaKey: ["A", "B", "C", "D"],
        options: ["true", "false"],
        incorrect_answers: ["True"],
      },
      {
        category: "Mythology",
        type: "multiple",
        difficulty: "easy",
        question:
          "Which of these mythological creatures is said to be half-man and half-horse?",
        correct_answer: "Centaur",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Minotaur", "Centaur", "Pegasus", "Gorgon"],
        incorrect_answers: ["Minotaur", "Pegasus", "Gorgon"],
      },
      {
        category: "Mythology",
        type: "multiple",
        difficulty: "easy",
        question: "What mythology did the god &quot;Apollo&quot; come from?",
        correct_answer: "Greek and Roman",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Roman and Spanish",
          "Greek and Roman",
          "Greek and Chinese",
          "Greek, Roman and Norse",
        ],
        incorrect_answers: [
          "Roman and Spanish",
          "Greek and Chinese",
          "Greek, Roman and Norse",
        ],
      },
    ],
  },
  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "27",
    image: "/assets/category_img/wildlife.jpg",
    category: "Animals",
    type: "multiple",
    difficulty: "medium",
    questions: [
      {
        category: "Animals",
        type: "multiple",
        difficulty: "easy",
        question: "What is the fastest  land animal?",
        correct_answer: "Cheetah",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Lion",
          "Cheetah",
          "Thomson&rsquo;s Gazelle",
          "Pronghorn Antelope",
        ],
        incorrect_answers: [
          "Lion",

          "Thomson&rsquo;s Gazelle",
          "Pronghorn Antelope",
        ],
      },
      {
        category: "Animals",
        type: "boolean",
        difficulty: "easy",
        question:
          "Kangaroos keep food in their pouches next to their children.",
        correct_answer: "False",
        alphaKey: ["A", "B", "C", "D"],
        options: ["False", "True"],
        incorrect_answers: ["True"],
      },
      {
        category: "Animals",
        type: "multiple",
        difficulty: "easy",
        question: "How many legs do butterflies have?",
        correct_answer: "6",
        alphaKey: ["A", "B", "C", "D"],
        options: ["2", "4", "6", "0"],
        incorrect_answers: ["2", "4", "0"],
      },
      {
        category: "Animals",
        type: "multiple",
        difficulty: "easy",
        question: "What do you call a baby bat?",
        correct_answer: "Pup",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Pup", "Cub", "Chick", "Kid"],
        incorrect_answers: ["Cub", "Chick", "Kid"],
      },
      {
        category: "Animals",
        type: "boolean",
        difficulty: "easy",
        question:
          "In 2016, the IUCN reclassified the status of Giant Pandas from endangered to vulnerable.",
        correct_answer: "True",
        alphaKey: ["A", "B", "C", "D"],
        options: ["True", "False"],
        incorrect_answers: ["False"],
      },
      {
        category: "Animals",
        type: "boolean",
        difficulty: "easy",
        question: "Rabbits are rodents.",
        correct_answer: "False",
        alphaKey: ["A", "B", "C", "D"],
        options: ["True", "False"],
        incorrect_answers: ["True"],
      },
      {
        category: "Animals",
        type: "multiple",
        difficulty: "easy",
        question: "What is the collective noun for a group of crows?",
        correct_answer: "Murder",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Pack", "Murder", "Gaggle", "Herd"],
        incorrect_answers: ["Pack", "Gaggle", "Herd"],
      },
      {
        category: "Animals",
        type: "multiple",
        difficulty: "easy",
        question: "What colour is the female blackbird?",
        correct_answer: "Brown",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Black", "White", "Yellow"],
        incorrect_answers: ["Black", "Brown", "White", "Yellow"],
      },
      {
        category: "Animals",
        type: "boolean",
        difficulty: "easy",
        question: "Rabbits are carnivores.",
        correct_answer: "False",
        alphaKey: ["A", "B", "C", "D"],
        options: ["False", "True"],
        incorrect_answers: ["True"],
      },
      {
        category: "Animals",
        type: "boolean",
        difficulty: "easy",
        question: "The internet browser Firefox is named after the Red Panda.",
        correct_answer: "True",
        alphaKey: ["A", "B", "C", "D"],
        options: ["False", "True"],
        incorrect_answers: ["False"],
      },
    ],
    alphaKey: ["A", "B", "C", "D"],
    options: [],
  },
  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "31",
    image: "/assets/category_img/anime.jpg",
    category: "Japanese Anime & Manga",
    type: "multiple",
    difficulty: "medium",
    questions: [
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "multiple",
        difficulty: "easy",
        question: "In the 9th Pokemon movie, who is the Prince of the Sea?",
        correct_answer: "Manaphy",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Manaphy", "Ash", "May", "Phantom"],
        incorrect_answers: ["Ash", "May", "Phantom"],
      },
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "boolean",
        difficulty: "easy",
        question:
          "The anime &quot;Lucky Star&quot; follows the story of one girl who is unaware she is God.",
        correct_answer: "False",
        alphaKey: ["A", "B", "C", "D"],
        options: ["true", "false"],
        incorrect_answers: ["True"],
      },
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "boolean",
        difficulty: "easy",
        question: "No Game No Life first aired in 2014.",
        correct_answer: "True",
        alphaKey: ["A", "B", "C", "D"],
        options: ["true", "false"],
        incorrect_answers: ["False"],
      },
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "multiple",
        difficulty: "easy",
        question: "In the anime Noragami who is one of the main protagonists?",
        correct_answer: "Yukine",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Karuha", "Yukine", "Mineha", "Mayu"],
        incorrect_answers: ["Karuha", "Mineha", "Mayu"],
      },
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "multiple",
        difficulty: "easy",
        question:
          "In the anime Black Butler, who is betrothed to be married to Ciel Phantomhive?",
        correct_answer: "Elizabeth Midford",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Rachel Phantomhive",
          "Elizabeth Midford",
          "Alexis Leon Midford",
          "Angelina Dalles",
        ],
        incorrect_answers: [
          "Rachel Phantomhive",
          "Alexis Leon Midford",
          "Angelina Dalles",
        ],
      },
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "multiple",
        difficulty: "easy",
        question:
          "In &quot;The Melancholy of Haruhi Suzumiya&quot; series, the SOS Brigade club leader is unknowingly treated as a(n) __ by her peers.",
        correct_answer: "God",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Alien", "Time Traveler", "God", "Esper"],
        incorrect_answers: ["Alien", "Time Traveler", "Esper"],
      },
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "multiple",
        difficulty: "easy",
        question:
          "In &quot;To Love-Ru&quot;, Ren and Run are from what planet?",
        correct_answer: "Memorze",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Deviluke", "Mistletoe", "Okiwana", "Memorze"],
        incorrect_answers: ["Deviluke", "Mistletoe", "Okiwana"],
      },
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "multiple",
        difficulty: "easy",
        question: "Who is the armored titan in &quot;Attack On Titan&quot;?",
        correct_answer: "Reiner Braun",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Reiner Braun",
          "Armin Arlelt",
          "Mikasa Ackermann",
          "Eren Jaeger",
        ],
        incorrect_answers: ["Armin Arlelt", "Mikasa Ackermann", "Eren Jaeger"],
      },
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "boolean",
        difficulty: "easy",
        question:
          "In the &quot;To Love-Ru&quot; series, Golden Darkness is sent to kill Lala Deviluke.",
        correct_answer: "False",
        alphaKey: ["A", "B", "C", "D"],
        options: ["False", "True"],
        incorrect_answers: ["True"],
      },
      {
        category: "Entertainment: Japanese Anime & Manga",
        type: "multiple",
        difficulty: "easy",
        question:
          "What name is the main character Chihiro given in the 2001 movie &quot;Spirited Away&quot;?",
        correct_answer: "Sen (Thousand)",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Hyaku (Hundred)",
          "Ichiman (Ten thousand)",
          "Juu (Ten)",
          "Sen (Thousand)",
        ],
        incorrect_answers: [
          "Hyaku (Hundred)",
          "Ichiman (Ten thousand)",
          "Juu (Ten)",
        ],
      },
    ],
  },
  {
    id: uuid(),
    rules: [
      "This quiz consists of 10 multiple-choice questions.",
      "Each MCQ question will carry 5 points for correct answer.",
      "There will be no negative marking.",
      "you are allotted a time of 15 min to complete the quiz.",
      "To be successful with the quiz, it is important to be conversant with all the topics. The quiz is designed to help you understand the concepts of the topics. All the best!",
      "Press SPACEBAR or ARROW KEY to navigate through the questions.",
    ],
    categoryNumber: "24",
    image: "/assets/category_img/politics.jpg",
    category: "Politics",
    type: "multiple",
    difficulty: "medium",
    questions: [
      {
        category: "Politics",
        type: "multiple",
        difficulty: "easy",
        question:
          "Whose 2016 presidential campaign slogan was &quot;Make America Great Again&quot;?",
        correct_answer: "Donald Trump",
        alphaKey: ["A", "B", "C", "D"],
        options: ["Donald Trump", "Ted Cruz", "Marco Rubio", "Bernie Sanders"],
        incorrect_answers: ["Ted Cruz", "Marco Rubio", "Bernie Sanders"],
      },
      {
        category: "Politics",
        type: "boolean",
        difficulty: "easy",
        question:
          "There was a satirical candidate named &quot;Deez Nuts&quot; running in the 2016 US presidential elections.",
        correct_answer: "True",
        alphaKey: ["A", "B", "C", "D"],
        options: ["False", "True"],
        incorrect_answers: ["False"],
      },
      {
        category: "Politics",
        type: "boolean",
        difficulty: "easy",
        question: "In 2016, the United Kingdom voted to stay in the EU.",
        correct_answer: "False",
        alphaKey: ["A", "B", "C", "D"],
        options: ["True", "False"],
        incorrect_answers: ["True"],
      },
      {
        category: "Politics",
        type: "multiple",
        difficulty: "easy",
        question: "How many people are in the U.S. House of Representatives?",
        correct_answer: "435",
        alphaKey: ["A", "B", "C", "D"],
        options: ["260", "435", "415", "50"],
        incorrect_answers: ["260", "415", "50"],
      },
      {
        category: "Politics",
        type: "boolean",
        difficulty: "easy",
        question: "Denmark has a monarch.",
        correct_answer: "True",
        alphaKey: ["A", "B", "C", "D"],
        options: ["True", "False"],
        incorrect_answers: ["False"],
      },
      {
        category: "Politics",
        type: "multiple",
        difficulty: "easy",
        question:
          "According to the United States Constitution, how old must a person be to be elected President of the United States?",
        correct_answer: "35",
        alphaKey: ["A", "B", "C", "D"],
        options: ["30", "40", "45", "35"],
        incorrect_answers: ["30", "40", "45"],
      },
      {
        category: "Politics",
        type: "multiple",
        difficulty: "easy",
        question: "Who was the 45th President of the United States?",
        correct_answer: "Donald Trump",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Barack Obama",
          "Donald Trump",
          "Bill Clinton",
          "George Bush",
        ],
        incorrect_answers: ["Barack Obama", "Bill Clinton", "George Bush"],
      },
      {
        category: "Politics",
        type: "boolean",
        difficulty: "easy",
        question:
          "Donald Trump won the popular vote in the 2016 United States presidential election.",
        correct_answer: "False",
        alphaKey: ["A", "B", "C", "D"],
        options: ["True", "False"],
        incorrect_answers: ["True"],
      },
      {
        category: "Politics",
        type: "boolean",
        difficulty: "easy",
        question:
          "Former president Theodore Roosevelt (1900-1908)  ran for another term under the Progressive Party in 1912.",
        correct_answer: "True",
        alphaKey: ["A", "B", "C", "D"],
        options: ["False", "True"],
        incorrect_answers: ["False"],
      },
      {
        category: "Politics",
        type: "multiple",
        difficulty: "easy",
        question:
          "Which former US president was nicknamed &quot;Teddy&quot; after he refused to shoot a defenseless black bear?",
        correct_answer: "Theodore Roosevelt",
        alphaKey: ["A", "B", "C", "D"],
        options: [
          "Woodrow Wilson",
          "James F. Fielder",
          "Theodore Roosevelt",
          "Andrew Jackson",
        ],
        incorrect_answers: [
          "Woodrow Wilson",
          "James F. Fielder",

          "Andrew Jackson",
        ],
      },
    ],
  },
];
